/* KAARKASH page motion: nothing arrives all at once.
   - A photograph marked data-kk-fade fades in when its file has arrived, over a frame that
     shimmers while it waits.
   - When a link to another page of the store is pressed, a line starts across the top of
     the window at once, so the press is answered before the next page is. It is drawn a
     third of the way across before it moves: Safari stops every animation the moment a
     page is on its way, and a line that had to grow from nothing would never be seen
     there. (Browsers that can, also fade one page into the next: that is asked for in the
     header's own styles.)
   If this script never runs, the stylesheet shows every photograph by itself after a
   moment: nothing depends on it to be seen. */
(function () {
  'use strict';
  if (window.__kkPage) return;

  var GIVE_UP = 10000;            // a page that has not come by then is not coming
  var line = null, waiting = 0;

  /* ---------- photographs ---------- */
  function shown(img) {
    img.classList.add('is-loaded');
    var frame = img.closest('[data-kk-frame]');
    if (frame) frame.classList.add('is-loaded');
  }
  // (a photograph still waiting for its turn, below, holds only a blank stand-in: not arrived)
  function images(scope) {
    (scope || document).querySelectorAll('img[data-kk-fade]:not(.is-loaded):not([data-src])').forEach(function (img) {
      if (img.complete) shown(img);
    });
  }
  function arrived(e) {
    var img = e.target;
    if (img && img.tagName === 'IMG' && img.hasAttribute('data-kk-fade') && !img.hasAttribute('data-src')) shown(img);
  }

  /* ---------- photographs that wait their turn ----------
     The page's main photograph comes first. On a slow phone the browser's own lazy loading
     still fetches every photograph within a few screens at once, and those queue in front of
     it (measured: the first product card took 7.5 s behind thirty others). So a photograph
     marked data-kk-later carries its address in data-src / data-srcset, and is fetched once the
     photographs marked fetchpriority="high" have arrived (or the page has loaded, or the
     shopper scrolls, or five seconds have passed): "near" (the default) when it comes within a
     couple of screens, "load" at once (slides beside the one shown, a closed drawer's photo). */
  var LATER_NEAR = '800px 0px';
  var laterOn = false, laterSeen = null;
  function wake(img) {
    if (!img.hasAttribute('data-src')) return;
    var src = img.getAttribute('data-src');
    if (img.hasAttribute('data-srcset')) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-srcset'); }
    img.src = src;
    img.removeAttribute('data-src');
    // a swiping card's copy of its first photograph (for the loop, snippets/card-swipe-js) sits
    // clipped past the end of its track, where it is never seen near: it wakes with the original
    var card = img.closest('[data-card-swipe]');
    if (card) card.querySelectorAll('[data-swipe-clone] img[data-src]').forEach(function (c) { if (c.getAttribute('data-src') === src) wake(c); });
  }
  function later(scope) {
    if (!laterOn) return;
    if (!laterSeen && 'IntersectionObserver' in window) {
      laterSeen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { laterSeen.unobserve(e.target); wake(e.target); } });
      }, { rootMargin: LATER_NEAR });
    }
    (scope || document).querySelectorAll('img[data-kk-later][data-src]').forEach(function (img) {
      if (img.getAttribute('data-kk-later') === 'load' || !laterSeen) wake(img); else laterSeen.observe(img);
    });
  }
  function laterStart() {
    if (laterOn) return;
    laterOn = true;
    later();
    // photographs put in later (a filter, the next page of a collection, a section reloaded)
    if ('MutationObserver' in window) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].addedNodes.length; j++) {
            var n = list[i].addedNodes[j];
            if (n.nodeType === 1) later(n.matches && n.matches('img') ? n.parentNode : n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  function laterWhenReady() {
    var first = Array.prototype.slice.call(document.querySelectorAll('img[fetchpriority="high"]'));
    var left = first.filter(function (img) { return !img.complete; });
    var go = function () { laterStart(); };
    if (!left.length) return go();
    var n = left.length;
    left.forEach(function (img) {
      var done = function () { if (--n <= 0) go(); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
    window.addEventListener('load', go, { once: true });
    window.addEventListener('scroll', go, { once: true, passive: true });
    window.addEventListener('touchstart', go, { once: true, passive: true });
    setTimeout(go, 5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', laterWhenReady); else laterWhenReady();
  // load and error do not travel up the page; they are heard on their way down
  document.addEventListener('load', arrived, true);
  document.addEventListener('error', arrived, true);

  /* ---------- the veil ----------
     A white cover (#kk-veil, first in the layout's body so it is there from the first paint).
     It lifts once the page can be shown, and comes down over the page again while a link
     is followed. The press is not held back: a listener heard after this one may still
     stop it (a panel opening), and then the veil goes up again at once. */
  var veil = document.getElementById('kk-veil'), uncover = 0;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Safari, and every browser on an iPhone or iPad (all WebKit), stops transitions and
  // animations the moment a page is on its way: a veil told to fade in as the press is
  // answered stays invisible there (measured: opacity 0 at 150 ms, then the next page).
  // So on WebKit the press is held for HOLD while the veil comes down, and the page is
  // then sent for by script. Elsewhere the press is not held back.
  var HOLD = 260;
  var ua = navigator.userAgent || '';
  var webkit = /iP(hone|ad|od)/.test(ua) || (/AppleWebKit/.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|SamsungBrowser|FxiOS|Firefox/.test(ua));
  function lift() { if (veil) { veil.classList.remove('is-on'); veil.classList.add('is-off'); } }
  function cover() { if (veil) { veil.classList.remove('is-off'); veil.classList.add('is-on'); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lift);
  else lift();
  setTimeout(lift, 1500);                              // a page slow to finish is shown anyway

  /* ---------- the line ---------- */
  function start() {
    if (!document.body) return;
    if (!line) {
      line = document.createElement('span');          // not a div: the theme hides every empty div
      line.className = 'kk-going';
      line.setAttribute('aria-hidden', 'true');
      document.body.appendChild(line);
    }
    clearTimeout(waiting);
    line.classList.remove('is-on');
    void line.offsetWidth;                            // start the line from the left each time
    line.classList.add('is-on');
    waiting = setTimeout(stop, GIVE_UP);
  }
  function stop() {
    clearTimeout(waiting);
    if (line) line.classList.remove('is-on');
  }
  function leaves(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download')) return false;
    if (link.target && link.target !== '_self') return false;
    var to;
    try { to = new URL(link.href, window.location.href); } catch (err) { return false; }
    if (to.origin !== window.location.origin || !/^https?:$/.test(to.protocol)) return false;
    // the same page (a place further down it) is not a page on its way
    if (to.pathname === window.location.pathname && to.search === window.location.search) return false;
    return true;
  }
  // Heard on the window, where a click arrives last: by then a link that opens a panel has
  // stopped itself, and the page has not yet begun to leave.
  // A listener put on the window later than this one may still stop the press: once they
  // have all been heard, a press that goes nowhere takes the line back.
  window.addEventListener('click', function (e) {
    if (!leaves(e)) return;
    start();
    if (veil && !reduced) {
      cover();
      clearTimeout(uncover);
      // a link that never brings a page (nothing to show, a download) must not leave the page white
      uncover = setTimeout(lift, 4000);
      if (webkit) {
        var href = e.target.closest('a[href]').href, stopped = false, pd = e.preventDefault;
        // a listener heard after this one may still stop the press (a panel opening): it is
        // heard through the event's own preventDefault, and then nothing is sent for
        e.preventDefault = function () { stopped = true; return pd.call(e); };
        pd.call(e);
        setTimeout(function () { if (stopped) { stop(); lift(); } }, 0);
        setTimeout(function () { if (stopped) { stop(); lift(); } else window.location.href = href; }, HOLD);
        return;
      }
    }
    setTimeout(function () { if (e.defaultPrevented) { stop(); lift(); } }, 0);
  });
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || form.method !== 'get' || (form.target && form.target !== '_self')) return;
    start();
  });
  // back from the page that was on its way, this one is shown as it was left
  window.addEventListener('pageshow', function () { stop(); lift(); });
  window.addEventListener('pagehide', function () { clearTimeout(waiting); });

  window.__kkPage = { images: images, going: start, arrived: stop };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { images(); });
  else images();
  window.addEventListener('load', function () { images(); });
  document.addEventListener('shopify:section:load', function (e) { images(e.target); });
})();
